import CommonModal from "@/modules/common/components/ui-kit/modals/common-modal";
import MobileModal from "@/modules/common/components/ui-kit/modals/mobile-modal";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import CreateTargetsTemplate from "@/modules/targets/components/target-configurations/targets-template/create-targets-template";
import { useTargetsTemplateContext } from "@/modules/targets/context/targets-template.context";
import useCreateAgentTargetTemplate from "@/modules/targets/hooks/create-agent-target-template.hook";

interface TargetsConfigTemplateProps {
  open: boolean;
  onClose: () => void;
}

const modalProps = {
  title: "Create Targets Template",
  cancelButtonText: "Cancel",
  confirmButtonText: "Save",
};

const TargetsConfigTemplate = ({
  open,
  onClose,
}: TargetsConfigTemplateProps) => {
  const { isMobile } = useScreenSize();
  const { setSubDepartment, form, subDepartment } = useTargetsTemplateContext();

  const handleCloseModal = () => {
    onClose();
    setSubDepartment(null);
    form.reset();
  };

  const { submitCreateAgentTargetTemplate } = useCreateAgentTargetTemplate({
    onSuccess: handleCloseModal,
  });

  return isMobile ? (
    <MobileModal
      open={open}
      onClose={handleCloseModal}
      {...modalProps}
      onConfirm={submitCreateAgentTargetTemplate}
    >
      <CreateTargetsTemplate subDepartmentUid={subDepartment?.uid!} />
    </MobileModal>
  ) : (
    <CommonModal
      open={open}
      onClose={handleCloseModal}
      {...modalProps}
      onConfirm={submitCreateAgentTargetTemplate}
    >
      <CreateTargetsTemplate subDepartmentUid={subDepartment?.uid!} />
    </CommonModal>
  );
};

export default TargetsConfigTemplate;
